package com.artvending.warden.screens.success

import androidx.compose.runtime.Composable
import com.artvending.warden.Page
import com.artvending.warden.ScreenModel
import kotlinx.datetime.LocalDateTime

class SuccessScreenModel(val dateTime: LocalDateTime?, val withWarning: Boolean = false): ScreenModel() {
	override val page: Page?
		get() = null
	
	
	@Composable
	override fun Display(scope: Any?) {
		scope.SuccessScreen(this)
	}
}


@Composable
expect fun Any?.SuccessScreen(model: SuccessScreenModel)